import api from 'Application/api/api';

const giveProjectQuestionYesNoAnswer = (
    projectId,
    questionId,
    isCustom,
    answer,
    cancelToken = null,
) =>
    api.post(
        `project-manager/projects/${projectId}/questionnaire/questions/${questionId}/${
            isCustom ? 1 : 0
        }/answers/yes-no`,
        {
            answer,
        },
        { cancelToken },
    );

export default giveProjectQuestionYesNoAnswer;
